export enum InvoiceStatus {
  PAID = 'paid',
  PENDING = 'pending'
}

export enum InvoiceStatusFilter {
  ALL = 'all',
  PAID = 'paid',
  PENDING = 'pending'
}

export const NUMBER_ITEMS_PER_REQUEST = 20;
export const INVOICE_HAS_PASSED_ONBOARDING_KEY = 'Invoice.hasPassedOnboarding';
export const INVOICE_TABS = [InvoiceStatusFilter.ALL, InvoiceStatusFilter.PENDING, InvoiceStatusFilter.PAID];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/invoice.ts